var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "sr-only" },
    [_vm._t("message", [_vm._v("\n\t\t" + _vm._s(_vm.message) + "\n\t")])],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }